import postClientSecurityOneTimeToken from '@/api/postClientSecurityOneTimeToken.ts';

export default function useCrossDomainLegacyRedirect() {
  const crossDomainRedirect = async (
    domain?: 'oldDashboard' | 'registration',
  ) => {
    // Get one-time token
    const oneTimeToken = await postClientSecurityOneTimeToken();

    // Create query string
    const queryString = window.location.search.replace('?', '&');

    const BASE_URL =
      domain === 'oldDashboard'
        ? import.meta.env.VITE_OLD_DASHBOARD_URL
        : import.meta.env.VITE_REGISTRATION_URL;

    // Construct redirect URL
    const redirectURL = `${BASE_URL}/one-time-token-login?token=${oneTimeToken}${queryString}`;

    // log user out from dashboard
    sessionStorage.clear();

    // Redirect to the constructed URL
    window.location.assign(redirectURL);
  };

  return { crossDomainRedirect };
}
